import { EMR_APIS } from "@/api_framework/api_config";
import { IRxViewUrlRequest, IRxViewUrlResponse } from "@/api_framework/api_modals/EMRs";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const useRxViewUrlAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (payload: IRxViewUrlRequest) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;

      const response = await axios
        .get(`${EMR_APIS?.RX_VIEW_URL?.baseURL}`, {
          params: {
            user_rx_key: payload?.user_rx_key,
            customer_user_id: payload?.customer_user_id,
          },
          headers: {
            Authorization: accessToken,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IRxViewUrlResponse>) => {
          if (res?.data?.status) {
            return {
              status: true,
              message: res?.data?.message ?? "RX view URL generated successfully",
              data: res?.data?.data ?? null,
            };
          }

          return {
            status: false,
            message: res?.data?.message ?? "Unable to generate RX view URL",
            data: res?.data?.data ?? null,
          };
        })
        .catch((e: AxiosError<IRxViewUrlResponse>) => {
          sendCurl(e?.config?.["curlCommand"]);
          const errorMessage = e?.response?.data?.message ?? "Unable to generate RX view URL";
          toast.error(errorMessage);
          return { status: false, message: errorMessage, data: null };
        });

      return response;
    } catch (e: any) {
      const errorMessage = "Server Error: " + e?.message;
      toast.error(errorMessage);
      return { status: false, message: errorMessage, data: null };
    }
  }, [configuration, sendCurl]);

  return execute;
};
